import { typedQueryClient, useTypedMutation } from "hooks/useTypedQuery";
import { useManufacturerDashboardFilters } from "modules/ManufacturerDashboard/hooks/useManufacturerDashboardFilters";
import { ManufacturerQueryKeys } from "modules/ManufacturerDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { MANUFACTURER_REQUEST_STATUSES } from "models/Manufacturer";

export type ManufacturerRequestPayload = {
  manufacturer_request_status: MANUFACTURER_REQUEST_STATUSES;
  manufacturer_request_id: number;
  decline_reason?: string;
};

export const useManufacturerRequestMutation = () => {
  const filters = useManufacturerDashboardFilters();

  return useTypedMutation({
    mutationFn: (payload: ManufacturerRequestPayload) => ApiInstance.post("/manufacturers/requests/update", payload),
    onSuccess: ({ manufacturer_request_status, manufacturer_request_id, decline_reason = "" }) => {
      const manufacturerList = typedQueryClient.getQueryData(ManufacturerQueryKeys.manufacturerListRequests(filters));
      if (!manufacturerList) return;

      const requestIdx = manufacturerList.manufacturer_requests.findIndex(request => request.id === manufacturer_request_id);
      if (requestIdx < 0) return;

      typedQueryClient.setQueryData(ManufacturerQueryKeys.manufacturerListRequests(filters), {
        ...manufacturerList,
        manufacturer_requests: manufacturerList.manufacturer_requests.with(requestIdx, {
          ...manufacturerList.manufacturer_requests[requestIdx],
          status: manufacturer_request_status,
          decline_reason
        })
      });
    }
  });
};
